import Game from 'Game';
import { FBTrackingEvent } from 'Utility/Tracking/FBTrackingEvent';
import { PlayerActions } from 'State/Player/PlayerActions';

export async function promptSubscribeBot(): Promise<boolean> {
    const canSubscribeBot = await Game.sdk.canSubscribeBot();

    if (canSubscribeBot) {
        Game.sdk.gameTracking(FBTrackingEvent.Bot_show);
        const result = await Game.sdk.subscribeBot();

        if (result) {
            Game.sdk.gameTracking(FBTrackingEvent.Bot_confirm);
        } else {
            Game.sdk.gameTracking(FBTrackingEvent.Bot_deny);
        }
    }

    // Must be called after `canSubscribeBot()` and `subscribeBot()`.
    const isSubscribed = await Game.sdk.isSubscribedToBot();

    PlayerActions.setBotSubscribed(isSubscribed);
    return isSubscribed;
}
